module.exports = __webpack_public_path__ + "img/numberEle.22fd26bb.svg";